// src/lib/locales.js

export const locales = {
  en: {
    // Navbar
    nav_space: "My Space",
    nav_chats: "Chats",
    nav_signin: "Sign In",
    nav_join: "Join the Sanctuary",
    nav_about: "About the Journey",
    nav_ethics: "Our Ethics",
    nav_support: "Seek Assistance",
    nav_crisis: "Immediate Safety",
    nav_terms: "Terms of Space",
    nav_privacy: "Privacy of Spirit",
    nav_sustain: "Nurture the Space",
    nav_foundation: "Our Foundation",
    nav_guidance: "Guidance",
    nav_integrity: "Integrity",
    nav_logout: "Logout",
    nav_lang_toggle: "You are resonating in",
    ob_hinglish_sub: "Select the frequency that feels right.",

    // Hero
    hero_headline: "A place where you can just talk… without being judged",
    hero_subheadline: "You don’t have to explain everything. You don’t have to be strong here.",
    hero_vent: "Talk to someone",
    hero_breath: "The Living Breath",
    hero_descent: "Begin your descent",
    hero_cta: "Start with one message",
    hero_nudge: "No pressure. You can leave anytime.",
    vent_freely: "You don’t have to explain everything.",

    // NEW: Soft Entry
    soft_entry_title: "Sometimes you don’t need answers.",
    soft_entry_body: "You just need someone who will sit with you.",

    // Section 2 - Invitation
    sec2_title: "A place you can come to… as you are",
    sec2_sub: "Antaryatra is a quiet space for the emotional and mental weight we all carry.",
    sec2_val_fix: "You don’t need to be “okay” before coming here.",
    sec2_val_strength: "You don’t need to know what to say.",
    sec2_val_content: "",
    sec2_desc: "Conversations happen at your pace — with people who listen, without trying to control your story.",

    // Section 3 - Intention
    sec3_title: "Why this space exists",
    sec3_sub: "Not everything needs fixing. Some things just need to be heard.",
    sec3_desc: "Many people aren’t looking for advice or labels. They just don’t want to feel alone with what they’re carrying. Antaryatra was built from lived experience — not trends.",
    sec3_quote: "“I just don’t want to be alone with this.”",

    // Section 4 - States
    sec4_title: "If you find yourself here…",
    sec4_state1: "Hurting quietly",
    sec4_state1_desc: "You don’t have to put it into perfect words.",
    sec4_state2: "Overwhelmed",
    sec4_state2_desc: "Take your time. Nothing here moves faster than you.",
    sec4_state3: "Tired of being strong",
    sec4_state3_desc: "You don’t have to carry everything alone right now.",
    sec4_state4: "Seeking clarity",
    sec4_state4_desc: "This is not a feed. It’s a conversation.",
    sec4_state5: "Just feeling something you can’t name",
    sec4_state5_desc: "That’s okay too.",
    sec4_nudge: "You can start small. Even one message is enough.",
    sec4_cta: "Start with one message",

    // Section 5 - Guides
    sec5_title: "If you’ve ever wanted to help someone… but didn’t know how",
    sec5_badge: "The Art of Presence",
    sec5_sub: "You don’t need to fix anyone here. You don’t need perfect words. You don’t need to have everything figured out. Sometimes, just being present is enough.",
    sec5_quote: "I don’t need to fix them. I just need to help them feel safe enough to face themselves.",
    sec5_guide_tagline: "Real people. Listening, not controlling.",
    sec5_apply: "Sit with someone once",
    
    // Trust Layer
    trust_title: "You can leave anytime.",
    trust_desc: "You don’t have to continue if it doesn’t feel right. There’s no pressure to stay. Only space to begin.",

    // Section 6 - Roots
    sec6_title: "What this space stands for",
    sec6_sub: "Support should feel human, not transactional. Here, your story is treated with dignity — not urgency. No performance. No pressure. No manipulation.",
    sec6_p1: "Offer presence",
    sec6_p1_desc: "A witnessing ear — not pressure, not quick fixes.",
    sec6_p2: "Encourage honesty",
    sec6_p2_desc: "No performance. No masks. No strength required.",
    sec6_p3: "Protect vulnerability",
    sec6_p3_desc: "Your story is sacred. Never content. Never exposed.",
    sec6_quote: "The future of support is not louder technology — it is more responsible humanity.",
    sec6_desc: "Where people don’t need to shout to be heard. Where care is slow, and presence matters more than speed.",

    // Section 8 - Promise
    sec8_title: "A quiet promise",
    sec8_promise: "You are not something to be solved.",
    sec8_desc: "You can take your time here — even if you don’t yet know what you’re looking for.",
    sec8_cta: "Talk when you’re ready",
    sec8_sub_cta: "We’ll meet you where you are.",
    sec8_nudge: "New here? Start with a single breath",
    sec8_new_here_cta: "Step inside",
    sec8_nudge_text: "New here?",

    // Footer
    foot_tagline: "The inner journey, held gently.",
    foot_copy: "© 2026 Antaryatra Sanctuary.",
    foot_micro: "Move at your pace • Leave anytime • No pressure",

    // Wisdom Section
    wisdom_loading: "Gathering wisdom from the library...",
    wisdom_gathering: "Gathering insights...",
    wisdom_for_you: "For You",
    wisdom_my_library: "My Library",
    wisdom_all_topics: "All Topics",
    wisdom_path_quiet: "This path is quiet.",
    wisdom_no_articles: "No articles found.",
    wisdom_read_more: "Read more",
    wisdom_title: "From the space",
    wisdom_desc: "Reflections and thoughts to help you navigate what you’re feeling.",
    wisdom_cta: "Enter quietly",

    // Morning Brew
    brew_title: "Daily Sip of Wisdom",
    brew_read_article: "Read Article",
    brew_read_time: "{time} read",

    // Banner
    banner_verify_email: "Verify your Email",
    banner_verify_desc: "Please verify your email to unlock all features and build trust.",
    banner_verify_btn: "Verify Now",
    banner_sending: "Sending...",
    banner_sent: "Verification link sent! Check your console/email.",
    banner_fail: "Failed to send link",
    banner_already: "Already verified!",

    // Guest Dashboard
    dash_guest_title: "Guest Sanctuary Session",
    dash_guest_desc: "Join the sanctuary to preserve your journey and speak with dedicated guides.",
    dash_guest_cta: "Claim your Space",
    wisdom_desc: "Reflections, guidance, and human stories curated to help you navigate your inner journey.",
    wisdom_cta: "Enter the Library",
    wisdom_fallback_title: "Inking soon...",
    wisdom_fallback_body: "This scroll is still being translated. Displaying English for now.",
    wisdom_reflections: "Reflections",
    wisdom_back: "Back to Wisdom Library",
    wisdom_read_more: "Read Full Article →",
    wisdom_further: "Further Wisdom",

    // Vent Box
    vent_title: "Empty Your Heart",
    vent_fire_title: "The Holy Pyre",
    vent_fire_desc: "For things that must be transformed into light.",
    vent_water_title: "The Open Sea",
    vent_water_desc: "For things that must be surrendered to the silence.",
    vent_freely: "You don’t have to explain everything.",
    vent_begin_quietly: "Begin quietly",
    vent_begin_desc: "You don’t have to explain everything. Just begin.",
    vent_canvas_water_title: "The Ocean's Edge",
    vent_canvas_water_desc: "Etch your burden below. The water is deep enough to hold it.",
    vent_canvas_fire_desc: "Offer your burden below. The flame will transform it.",
    vent_placeholder: "I feel heavy because...",
    vent_release_water: "Release depths",
    vent_release_fire: "Offer to light",
    vent_anim_water: "The ocean is vast. This stone is small. You are lighter now.",
    vent_anim_fire: "Accepted by the flame. Your burden is lightened.",
    vent_complete_title: "You are lighter now.",
    vent_complete_desc: "The weight you carried has been surrendered to the silence.",
    vent_complete_desc_new: "You are now ready to occupy your space in the Sanctuary.",
    vent_complete_cta: "Return to Sanctuary",
    vent_complete_cta_new: "Enter the Sanctuary",
    vent_complete_cancel: "Return to the outer world",
    vent_mute: "Mute Ambient Sound",
    vent_unmute: "Unmute Ambient Sound",

    // The Living Breath
    breath_title: "The Living Breath",
    breath_desc: "How is your energy flowing today?",
    breath_turb_title: "Turbulence",
    breath_turb_desc: "Finding your anchor amidst the storm.",
    breath_still_title: "Stillness",
    breath_still_desc: "In quietude, your truth becomes clear.",
    breath_inert_title: "Inertia",
    breath_inert_desc: "Resting is not stopping; it is gathering strength.",
    breath_label_turb: "Restless",
    breath_label_inert: "Heavy",
    breath_label_still: "Centered",
    breath_wake: "Touch to wake",

    // Sanctuary Settings
    set_title: "Settings that Resonate",
    set_theme_title: "Internal Weather",
    set_light: "Light",
    set_dark: "Dark",
    set_lang_title: "Soul's Language",
    set_lang_search: "Search for language...",
    set_lang_resonate: "Select the language that resonates.",
    set_lang_en_sub: "The Global Tongue",
    set_lang_hi_sub: "Hinglish",
    set_tagline: "Your pace. Your space.",
    set_lang_missing: "This tongue is not yet part of our sanctuary.",
    set_close_account: "Close My Account",
    set_close_warning_title: "A Moment of Pause?",
    set_close_warning_desc: "Closing your account will hide your presence and end your active journey. Your reflections and history will be preserved safely in 'The Books of Life' for safety audits, but you will no longer be able to enter.",
    set_cancel: "Stay in Sanctuary",
    set_confirm_close: "Confirm Closure",

    // Mobile Bottom Nav
    nav_home: "My Space",
    nav_chats_tab: "Chats",
    nav_wisdom_tab: "Wisdom",
    nav_profile_tab: "Profile",

    // Onboarding
    ob_nudge: "This will take less than a minute.",
    ob_inhale: "Breathe in…",
    ob_hold: "Hold…",
    ob_exhale: "Let it go…",
    ob_safe_space_title: "Create your space",
    ob_safe_space_sub: "Your identity stays private and safe.",
    ob_real_name_label: "Real Name (Kept Private)",
    ob_real_name_sub: "This stays between you and the universe. 🔒",
    ob_email_label: "Email Address",
    ob_email_error: "That email doesn't look quite right.",
    ob_dob_label: "Date of Birth",
    ob_pass_label: "Create Password",
    ob_pass_len: "At least 8 characters",
    ob_pass_upper: "One uppercase letter (A-Z)",
    ob_pass_num: "One number (0-9)",
    ob_captcha_label: "Quick Check: What is {a} + {b}?",
    ob_captcha_placeholder: "Your Answer",
    ob_cta_begin: "Continue",
    ob_nudge_bottom: "You can leave anytime.",
    ob_login_prompt: "Already have an account?",
    ob_login_link: "Log in",
    ob_anon_name_label: "Public Anonymous Name",
    ob_anon_name_gen: "Generate New",
    ob_anon_name_sub: "This is how you will appear to others. Your real name stays hidden.",
    ob_anon_name_magic: "This is you, in this space. ✨ It suits you.",
    ob_age_warn_title: "Age Restriction",
    ob_age_warn_desc: "We deeply respect your journey, but Antaryatra is currently designed for individuals 18 years and older due to data privacy regulations.",
    ob_age_crisis: "If you need immediate support, please contact Childline (1098).",
    ob_gender_label: "Gender",
    ob_aadhaar_label: "Aadhaar ID (Optional)",
    ob_aadhaar_sub: "Kept under lock, seen by no one.",
    ob_back: "Back",
    ob_finish: "Begin Journey",
    ob_starting: "Starting...",
    ob_step1_title: "A new beginning",
    ob_step1_head: "Begin your journey within.",
    ob_step1_body: "You don't have to have it all figured out to take the first step.",
    ob_step2_title: "You're almost there",
    ob_step2_head: "Give yourself a name in this space.",
    ob_step2_body: "Your anonymous name is yours to choose — a small act of self-definition.",
    ob_storm_head: "The storm has a center.",
    ob_storm_body: "A restless mind is a powerful engine. We are here to help you find your anchor today.",
    ob_still_head: "Stillness is your strength.",
    ob_still_body: "Your inner quietude is clear. In this space, we will help you hear what the silence is saying.",
    ob_inert_head: "Honor the pause.",
    ob_inert_body: "Even the earth rests before spring. Take your first slow, conscious step into the sanctuary.",

    // Dashboard
    dash_inner_garden: "My Inner Garden",
    dash_burn_worry: "Burn a Worry",
    dash_nurture_tips: "Nurturing Suggestions",
    dash_diary_cta: "Continue your Soul Diary",
    dash_find_guide: "Find Your Guide",
    dash_support_circle: "Circle of Support",
    dash_pending_req: "Pending Requests",
    dash_impact: "Your Impact",
    dash_profile_views: "Profile Views",
    dash_online: "Online",
    dash_offline: "Offline",
    dash_availability: "Availability",
    dash_connect_guide: "Connect with a Guide",
    dash_search_conv: "Search conversations...",
    chat_search_placeholder: "Search conversations...",
    chat_intro_title: "Your Chats",
    chat_intro_body: "Select a conversation from the left to continue your journey, or simply breathe.",
    dash_recent: "Recent",
    dash_favourites: "Favourites",
    dash_archived: "Archived",
    dash_archived_chat: "Archived chat",
    dash_silence_allowed: "Silence is allowed here.",
    dash_take_time: "Conversations don’t need to start immediately. Take your time.",
    dash_start_breathing: "Begin Breathing",
    dash_mood_graph_loading: "Loading graph...",
    dash_mood_save_error: "Could not save mood",
    dash_tab_suggested: "Suggested",
    dash_new: "New",
    prof_my_profile: "My Profile",
    prof_manage_details: "Manage your personal details and preferences.",
    prof_expertise_label: "My Expertise (Categories)",
    prof_journey_saved_msg: "Your journey is saved. You can return whenever you wish.",
    dash_weekly_impact: "Weekly Impact",
    dash_sessions_label: "Sessions",
    dash_rating_label: "Rating",
    dash_updated_just_now: "Updated just now. Tap to see details.",
    dash_provider_console: "Provider Console",
    dash_presence_sub: "Manage your presence",
    dash_record_reflections: "Record your reflections",
    dash_availability_label: "Availability",
    chat_privacy_notice: "This conversation is private and safe.",
    cat_manage_title: "Manage Your Areas",
    cat_seeker_sub: "Select the paths where you seek guidance.",
    cat_provider_sub: "Select the areas where you provide support.",
    cat_label_EMOTIONAL_SUPPORT: "Emotional Support",
    cat_desc_EMOTIONAL_SUPPORT: "Anxiety, stress, loneliness, just want to talk",
    cat_label_RELATIONSHIPS: "Relationships & Social Life",
    cat_desc_RELATIONSHIPS: "Relationships, parenting, marriage, bullying",
    cat_label_LIFE_CHALLENGES: "Life Challenges",
    cat_desc_LIFE_CHALLENGES: "Career, finance, education, business",
    cat_label_HIGH_RISK: "High Risk (Strict)",
    cat_desc_HIGH_RISK: "Specialized support for sensitive situations",
    cat_label_SPIRITUAL: "Spiritual & Personal Growth",
    cat_desc_SPIRITUAL: "Self-discovery, spiritual evolution",
    cat_label_SUICIDE_PREVENTION: "Suicide Prevention",
    cat_desc_SUICIDE_PREVENTION: "Suicide prevention and crisis support",
    cat_label_ADDICTION: "Addiction Recovery",
    cat_desc_ADDICTION: "Addiction and substance abuse recovery",
    cat_label_TRAUMA: "Trauma & Abuse Support",
    cat_desc_TRAUMA: "Trauma recovery and abuse support",
    chat_archive_action: "Archive Chat",
    chat_unarchive_action: "Unarchive Chat",
    chat_welcome_head: "Welcome Back",
    chat_welcome_body: "Take a deep breath O' seeker. You are safe to share here.",
    chat_welcome_namaste: "Namaste & Welcome",
    chat_welcome_body: "Take a deep breath O' seeker. You are safe to share here.",
    chat_welcome_body_guide: "Breathe deeply, Guide. Your presence is the sanctuary.",
    chat_welcome_time: "You don't have to start everything now. Take your time O' Seeker.",
    chat_welcome_time_guide: "The space is quiet. Stay centered and ready to listen.",
    chat_empty_matches: "No matches found",
    chat_empty_favs: "No favorites yet",
    chat_empty_archived: "No archived chats",
    chat_empty_conv: "No conversations yet",
    chat_role_guide: "Guide",
    chat_role_seeker: "Seeker",

    // Errors
    err_generic: "Something went wrong.",
    gate_logout_title: "Leaving so soon?",
    gate_logout_body: "Are you sure you want to leave your safe space?",
    gate_cancel_logout: "Nope!",
    gate_confirm_logout: "Logout",
    gate_logout_prep: "Breathe out... preparing your departure.",
    gate_logout_done: "Safe travels on the outer world.",
    prof_personal_details: "Personal Details",
    prof_username: "Username",
    prof_full_name: "Full Name",
    prof_gender: "Gender",
    prof_no_expertise: "No expertise selected.",
    prof_update_success: "Profile updated successfully",
    prof_update_fail: "Failed to update profile",
    prof_categories_success: "Expertise updated successfully",
    prof_categories_fail: "Failed to update categories",
    err_starting: "Starting...",

    // Phase 3: Auth & Gateway
    auth_login_welcome: "Aaiye, aapka h intezaar tha",
    auth_login_btn: "Login",
    auth_forgot_title: "Reset Password",
    auth_forgot_desc: "Enter your email address and we'll send you a link to reset your password.",
    auth_forgot_email_label: "Email Address",
    auth_forgot_email_placeholder: "you@example.com",
    auth_forgot_cta: "Send Reset Link",
    auth_forgot_back: "Back to Sign In",
    auth_2fa_verify_btn: "Verify",
    auth_2fa_back_link: "Back to Login",

    // Profile
    prof_gender_male: "Male",
    prof_gender_female: "Female",
    prof_gender_lgbt: "LGBT+ Family",
    acc_email_label: "Email",
    auth_forgot_check_mail: "Check your mail",
    auth_forgot_sent_to: "If an account exists for",
    auth_forgot_instructions: "you will receive a password reset link shortly.",
    auth_login_prompt: "Continue your journey with Antaryatra.",
    auth_recovery_link: "Forgot password?",
    auth_new_text: "New here?",
    auth_new_link: "Create an account",
    auth_new_prompt: "New here? Create an account",
    gateway_title: "How do you wish to enter?",
    gateway_sub: "Every journey requires a first step. Choose the path that calls to you.",
    gateway_seeker_path: "I seek guidance",
    gateway_seeker_desc: "Find a safe space to share, reflect, and be heard by empathetic listeners.",
    gateway_guide_path: "I wish to guide",
    gateway_guide_desc: "Offer your light to those in the dark. Verification Required.",
    gateway_cta: "Begin Path",

    // Dashboard Refinements
    dash_recent_chats: "Recent chats",
    dash_mood_tracker: "Mood Tracker",
    dash_mood_sub: "Nurturing your emotional rhythm",
    dash_explore_providers: "Explore Providers",
    dash_view_all: "View all",
    dash_view_profile: "View Profile",
    dash_chat_now: "Chat now",
    dash_mood_heavy: "Heavy",
    dash_mood_still: "Still",
    dash_mood_bright: "Bright",
    dash_mood_recorded_toast: "Mood recorded! thank you for sharing.",
    dash_mood_current_state: "Current State",
    dash_mood_feeling_msg_start: "You're feeling",
    cookie_title: "Privacy of your Journey",
    cookie_desc: "We use only essential cookies to preserve your presence and preferences in the Sanctuary. No tracking, just space.",
    cookie_action: "I Understand",
    cookie_read_more: "Read More",
    privacy_sec5_title: "Data Deletion & Right to be Forgotten",
    privacy_sec5_desc: "You may choose to delete your account at any time through your profile settings. Upon deletion, your personal data will be held in a 'deactivated' state for 30 days. During this period, you can retrieve your account by simply logging back in. After 30 days of inactivity, your PII (Personally Identifiable Information) is permanently purged from our active databases. Note: For legal compliance and safety audits, we may retain anonymized records or minimal audit logs as required by law.",
    set_slide_to_confirm: "Slide to confirm deletion",
    dash_mood_feeling_msg_end: "Take a deep breath.",
    dash_mood_graph_empty: "Start tracking your mood to see your emotional rhythm here.",
    dash_mood_graph_range: "Last 7 Days",
    dash_explore_loading: "Finding guides for you...",
    dash_explore_empty: "No one is available right now.",
    dash_explore_empty_sub: "You can wait, expand your categories, or return later — at your pace.",
    dash_explore_modal_title: "Available Providers",
    dash_explore_msg_btn: "Message",
    dash_recent_loading: "Connecting to your space...",
    dash_recent_empty: "No chats yet. Reach out to a guide whenever you're ready.",
    dash_recent_empty_title: "The space is quiet.",
    dash_recent_empty_sub: "Connect with a guide to start your journey.",
    dash_recent_empty_sub_provider: "No active sessions.",
    dash_recent_start_cta: "Start a conversation",
    dash_recent_msg_start: "Start a conversation...",
    dash_recent_msg_started: "Conversation started...",
    dash_recent_prefix_me: "You: ",
    dash_recent_media_image: "📷 Image",
    dash_recent_media_audio: "🎤 Voice Note",
    dash_recent_media_file: "📎 Attachment",
    dash_recent_media_letter: "📜 Letter",

    dash_nurture_happy: "\"A joyful heart is a sun in the soul.\" Preserve this radiance in your journey log.",
    dash_nurture_sad: "It's okay to let go. Breathe your heavy thoughts into the fire and find release.",
    dash_nurture_neutral: "Stability is strength. Deepen your presence with a mindful breathing session.",
    dash_nurture_other: "Every emotion is a wave on the ocean. Reach out if you need an anchor.",

    // Diary
    diary_title: "My Sanctuary Journal",
    diary_empty: "Your diary is empty",
    diary_empty_sub: "Visit the Digital Diary in the Sanctuary to start writing.",
    diary_view_all: "View All",
    diary_view_all: "View All",
    diary_pen_down: "Pen Down",
    diary_placeholder: "Begin your reflection...",
    diary_mood_label: "Mood",
    diary_write_prompt: "Please write something first.",
    diary_save_success: "Entry saved to your sanctuary",
    diary_save_error: "Failed to save entry",
    diary_stop_label: "Stop",
    diary_stop_tooltip: "Stop Recording",
    diary_start_tooltip: "Start Voice Input",
    diary_prompt_title: "Today's Prompt",
    diary_weather_title: "Internal Weather",
    diary_entry_date: "Entry Date",
    diary_del_confirm: "Are you sure you want to delete this memory?",
    diary_del_success: "Entry deleted",
    diary_del_error: "Failed to delete entry.",
    diary_del_tooltip: "Delete Entry",
    diary_reflecting_on: "Reflecting on",
    diary_archive_title: "Reflection Archive",
    diary_memories_count: "{count} memories recorded",
    diary_load_error: "Could not load your diary entries.",

    // Grounding
    ground_morning: "Namaste, Good Morning",
    ground_afternoon: "Namaste, Good Afternoon",
    ground_evening: "Namaste, Good Evening",
    ground_take_moment: "take a moment",

    // Context Card
    ctx_mutual: "Mutual Focus",
    ctx_primary: "Primary Focus",
    ctx_more: "+{count} more",
    ctx_dismiss: "Dismiss for now",
    ctx_age: "Age",
    ctx_critical: "Critical Support",
    ctx_emotional: "Emotional Support",
    ctx_rel: "Relationships",
    ctx_life: "Life Challenges",
    ctx_spirit: "Spiritual Growth",

    // Breathing
    breath_title: "Breathing Space",
    breath_quote: "\"Quiet the mind, and the soul will speak.\"",
    breath_headphones: "Use headphones for the best experience.",
    breath_begin: "Begin Session",
    breath_inhale: "Inhale",
    breath_hold: "Hold",
    breath_exhale: "Exhale",
    breath_inhale_inst: "Breathe in deeply through your nose...",
    breath_hold_inst: "Hold it... let stillness settle in...",
    breath_exhale_inst: "Exhale slowly through your mouth... release everything.",

    // Emotional Rhythm (Pre-chat)
    pc_title: "Emotional Rhythm",
    pc_question: "How are you feeling?",
    pc_context: "Sharing this helps your guide understand where you are right now.",
    pc_continue: "Continue to Chat",
    pc_skip: "Skip checks",

    // Moods
    mood_anxious: "Anxious",
    mood_lonely: "Lonely",
    mood_overwhelmed: "Overwhelmed",
    mood_hopeful: "Hopeful",
    mood_chatting: "Just chatting",
    mood_confused: "Confused",
    mood_happy: "Happy",
    mood_sad: "Sad",
    mood_neutral: "Neutral",

    // Sustain
    sustain_title: "Sustain the Sanctuary",
    sustain_sub: "We rely on guardians like you to keep this space safe and open for everyone.",
    sustain_global_tab: "Global Support (PayPal)",
    sustain_india_tab: "India (UPI)",
    sustain_guardian_title: "Become a Guardian",
    sustain_guardian_desc: "Support us securely from anywhere in the world.",
    sustain_paypal_cta: "Contribute via PayPal",
    sustain_paypal_trust: "Trusted worldwide. Secure payment via PayPal.",
    sustain_upi_title: "Support via UPI",
    sustain_upi_desc: "Zero fees. Direct support using any UPI app.",
    sustain_copy: "Copy",
    sustain_copied: "Copied",
    sustain_quote: "\"The integrity of the space is worth more than the speed of its growth.\"",
    support_reach_out_title: "Reach out to us",
    support_reach_out_body: "Have any suggestions, complaints or feedback for Antaryatra? Do not hesitate for one second- reach us out at care@antaryatra-app.com. We are here to assist you ASAP.",

    // Apply
    apply_guide_title: "The Path of the Guide",
    apply_guide_trust: "To guide another is a sacred trust.",
    apply_guide_not_marketplace: "Antaryatra is not a marketplace; it is a sanctuary.",
    apply_guide_reflect: "Before you can enter, we ask you to reflect.",
    apply_begin_reflection: "Begin Reflection",
    apply_prev_step: "Previous Step",
    apply_success_title: "Application Received",
    apply_success_msg: "Thank you for sharing your light. Our council will review your reflection. If it resonates, we will invite you for a Virtual Tea via email.",

    // Notifications
    note_title: "Notifications",
    note_empty: "The space is quiet.",
    note_empty_sub: "New updates will appear here.",
    note_mark_all: "Mark all as read",
    note_clear_all: "Clear all",
    note_CHAT_NEW_MESSAGE: "{name} sent you a message.",
    note_WISDOM_NEW_SCROLL: "A new scroll was added: {title}",
    note_GUIDE_VERIFIED: "Your guide path is now verified. Welcome, {name}.",
    note_GUIDE_PENDING: "We are witnessing your application, {name}.",
    note_REACTION_NEW: "{name} reflected on your thought.",
    note_BREATH_STREAK: "7-day breathing streak! Keep flowing.",
    note_MOOD_PROMPT: "How is your inner weather today?",

    // About Page
    about_quiet: "A Quiet",
    about_rebellion: "Rebellion",
    about_intro: "Antaryatra is not a startup; it is a human-led architecture for the modern world.",
    about_exhaustion: "We built this because we know the exhaustion of 'performing' on the loud, extractive internet.",
    about_space: "We provide a space for slowing down—a digital sanctuary where you don't have to be perfect, you just have to be",
    about_you: "you",
    about_philosophy_title: "Our Philosophy",
    about_philosophy_body: "We believe technology should serve the human soul, not harvest it. We are 'Calm yet Firm'—gentle with people, but fierce about protecting their peace.",
    about_version: "Sanctuary v1.0",

    // Ethics & Safety Page
    ethics_title: "Ethics & Safety",
    ethics_tagline: "Our promise to you, written in plain language.",
    ethics_data_title: "Your Data is Yours",
    ethics_data_desc: "We do not sell your data. We do not share your conversations with advertisers. Your private thoughts are not a commodity here; they are the foundation of your trust in us.",
    ethics_anon_title: "Anonymity First",
    ethics_anon_desc: "You don't have to use your real name if you don't feel safe. We protect your identity so you can speak your truth without fear of judgment. You are welcome here exactly as you are.",
    ethics_abuse_title: "Zero Tolerance for Abuse",
    ethics_abuse_desc: "This is a sanctuary. We maintain a zero-tolerance policy for harassment, hate speech, or exploitation. We have built firm boundaries to ensure this space remains peaceful; violators are banned immediately.",
    ethics_human_title: "Human-Led, Not AI-Driven",
    ethics_human_desc: "You are talking to real people. While we use technology to connect you, we believe genuine support happens through human resonance, not algorithms.",
    ethics_integrity_title: "The Integrity Protocol",
    ethics_integrity_desc: "We operate on a 'Value-for-Value' model. We do not chase engagement metrics or likes. Our internal compass is simple: every feature we build must protect the user's peace and maintain the highest level of ethical integrity.",
    ethics_crisis_title: "A Note on Crisis",
    ethics_crisis_desc: "Antaryatra is a peer support platform designed for slowing down and finding clarity. It is not a replacement for emergency medical care. If you or someone else is in immediate danger or experiencing a life-threatening emergency, please contact your local emergency services immediately.",
    
    // Support Page
    support_title: "Need Help?",
    support_desc: "Whether you found a bug, have a safety concern, or just want to suggest a feature—we are listening.",
    support_contact_title: "Contact Us",
    support_reply_time: "We usually reply within 24 hours.",

    // Crisis Page
    crisis_title: "In Crisis?",
    crisis_desc: "If you are in immediate danger or thinking about self-harm, please reach out for immediate professional help.",
    crisis_hope: "You are not alone, and there is hope.",
    crisis_platform_note: "Antaryatra is a peer support platform and not equipped to handle life-threatening emergencies.",
    crisis_instruction: "Please use the numbers above for immediate crisis medical support.",

    // Terms Page
    terms_title: "Terms of Service",
    terms_updated: "Last Updated: February 5, 2026",
    terms_disclaimer_title: "Medical Disclaimer",
    terms_disclaimer_1: "ANTARYATRA IS NOT A MEDICAL SERVICE, SUICIDE PREVENTION LINE, OR CLINIC.",
    terms_disclaimer_2: "THE CONTENT AND INTERACTIONS ON THIS PLATFORM ARE FOR INFORMATIONAL AND PEER-SUPPORT PURPOSES ONLY. THEY DO NOT CONSTITUTE MEDICAL ADVICE, DIAGNOSIS, OR TREATMENT.",
    terms_disclaimer_3: "IF YOU ARE THINKING ABOUT SUICIDE, OR IF YOU ARE CONSIDERING HARMING YOURSELF OR OTHERS, OR IF YOU FEEL THAT ANY OTHER PERSON MAY BE IN DANGER, PLEASE CALL YOUR LOCAL EMERGENCY SERVICES IMMEDIATELY.",
    terms_sec1_title: "1. Nature of Service: A \"Platform\"",
    terms_sec1_p1: "Antaryatra acts solely as a technological venue (a \"Platform\"). We connect individuals seeking support (\"Seekers\") with individuals offering support (\"Providers\" or \"Guides\").",
    terms_sec1_p2: "We do not employ these Providers. We do not direct their advice. We are not responsible for the content of the conversations.",
    terms_sec1_p3: "You acknowledge that your interactions are at your own risk.",
    terms_sec2_title: "2. User Conduct & Safety",
    terms_sec2_age: "Age Requirement:",
    terms_sec2_age_desc: "You must be at least 18 years old to use this platform independently.",
    terms_sec2_zero: "Zero Tolerance:",
    terms_sec2_zero_desc: "Harassment, hate speech, sexual solicitation, or predatory behavior will result in an immediate, permanent ban.",
    terms_sec2_privacy: "Privacy Respect:",
    terms_sec2_privacy_desc: "Do not share personal contact details (phone numbers, addresses) in the chat. Keep interactions within the platform for safety.",
    terms_sec3_title: "3. For Providers (Guides)",
    terms_sec3_intro: "By signing up as a Provider, you agree that:",
    terms_sec3_1: "You are an Independent Contractor/Volunteer, not an employee of Antaryatra.",
    terms_sec3_2: "You will NOT offer medical diagnoses or prescribe medication.",
    terms_sec3_3: "You will treat every user with dignity, regardless of their background.",
    terms_sec3_4: "You will not solicit users to pay you off-platform.",
    terms_sec4_title: "4. Termination",
    terms_sec4_desc1: "We reserve the right to suspend or terminate your access to Antaryatra at any time, for any reason, without notice or liability.",
    terms_sec4_desc2: "This is especially true if you violate the \"spirit\" of the sanctuary—safety, kindness, and respect.",
    terms_sec5_title: "5. Limitation of Liability",
    terms_sec5_desc: "TO THE FULLEST EXTENT PERMITTED BY LAW, ANTARYATRA INC. SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, INCURRED AS A DIRECT OR INDIRECT RESULT OF YOUR USE OF THE PLATFORM.",

    // Privacy Page
    privacy_title: "Privacy & Cookie Policy",
    privacy_tagline: "Your secrets are safe here.",
    privacy_short_title: "The Short Version",
    privacy_short_desc: "We don't sell your data. We don't track you across the web. We only store what is necessary to connect you with a listener and keep the platform safe.",
    privacy_sec1_title: "1. Data We Collect",
    privacy_sec1_acc: "Account Info:",
    privacy_sec1_acc_desc: "Email address (hashed/encrypted where possible), optional Username, and Profile details you choose to share.",
    privacy_sec1_chat: "Chat Logs:",
    privacy_sec1_chat_desc: "We store chat history securely to allow you to revisit conversations. These are encrypted at rest.",
    privacy_sec1_usage: "Usage Data:",
    privacy_sec1_usage_desc: "Basic logs of when you log in or encounter errors, to help us fix bugs.",
    privacy_sec2_title: "2. How We Use Your Data",
    privacy_sec2_li1: "To connect you with the right support Provider.",
    privacy_sec2_li2: "To detect and ban abusive users (safety moderation).",
    privacy_sec2_li3: "To send you important account updates (like password resets).",
    privacy_sec2_li4: "WE DO NOT SELL YOUR DATA TO ADVERTISERS.",
    privacy_sec3_title: "3. Cookie Policy",
    privacy_sec3_intro: "We believe in digital minimalism. We use only Strictly Necessary Cookies:",
    privacy_sec3_auth_title: "Authentication Cookies",
    privacy_sec3_auth_desc: "To keep you logged in securely (HttpOnly).",
    privacy_sec3_pref_title: "Preference Cookies",
    privacy_sec3_pref_desc: "To remember if you prefer Dark Mode or Light Mode.",
    privacy_sec3_tracking: "We do not use third-party tracking pixels (like Facebook Pixel) that follow you around the internet.",
    privacy_sec4_title: "4. Security",
    privacy_sec4_desc1: "We use industry-standard encryption (SSL/TLS) for data in transit.",
    privacy_sec4_desc2: "Our team has strict access controls, meaning your private chats are not casually accessible to developers unless required for a safety investigation (e.g., court order or life-safety threat).",
    premium_history_title: "Deep Insights",
    premium_history_desc: "Unlock your 30-day emotional rhythm and deep patterns with Guardian access.",
    premium_history_cta: "Become a Guardian",
    
    // Onboarding & Gateway
    'gateway_title': 'Choose Your Path',
    'gateway_subtitle': 'Every journey begins with an intention.',
    'gateway_seeker_desc': 'I am here to find peace, share my heart, and seek guidance.',
    'gateway_guide_desc': 'I am here to serve others, share wisdom, and light the path.',
    'gateway_note': 'Note: Your choice will shape your experience in the Sanctuary.',
    'ob_real_name_sub': "If you'd like to share, otherwise feel free to keep it private.",
    'ob_age_sub': "This helps us keep the space safe for everyone.",
    'ob_legal_sub': 'I confirm that I am over 18 and agree to the Terms and Privacy Policy.',
    'ob_final_step': 'Final Step',
    'ob_commitment_sub': 'To maintain the sanctity of Antaryatra, we ask for your commitment.',
    
    // Quiz & Guide
    'quiz_next': 'Next Question',
    'quiz_prev': 'Pichla Step', // User specifically requested this to be Hinglish even in English? No, let's keep it Next Question/Previous Step in English.
    'quiz_start': 'Chintan (Reflection) Shuru Karein',
    'quiz_mirror_title': 'The Mirror of Truth',
    'guide_circle_title': 'The Circle of Ten',
    'guide_circle_subtitle': 'A Call from the All-Seer',
    'guide_circle_desc': '"The All-seer is searching for the first 9 souls to join the original circle of ten. This is not a job; it is a sacred witnessing."',
    'guide_sanctuary_note': 'Antaryatra is not a marketplace; it is a sanctuary. Before you can enter the circle, you must walk through the mirror of truth.',
    'ob_security_title': 'Accountability Layer',
    'ob_security_label': 'Slide to Verify',
    'ob_security_success': 'Welcome home',
    'ob_security_note': 'Just a small step to ensure this space remains human and intentional.',
    'ob_name_label': 'Real Name (Kept Private)',
  },
  hi: {
    // Navbar
    nav_space: "Meri Jagah",
    nav_chats: "Baatein",
    nav_signin: "Andar Aayein",
    nav_join: "Sanctuary se judein",
    nav_foundation: "Humari Buniyaad",
    nav_guidance: "Guidance",
    nav_integrity: "Asool",
    nav_logout: "Bahir Niklein",
    nav_about: "Yatra ke baarein mein",
    nav_ethics: "Bharosa",
    nav_support: "Madad mangiye",
    nav_crisis: "Tatkal Suraksha",
    nav_terms: "Parampara. Pratishtha. Anushasan.",
    nav_privacy: "Privacy ka poora khayal",
    nav_sustain: "Sanctuary ko sambhalein",
    nav_lang_toggle: "Aapki resonance hai",
    ob_hinglish_sub: "Woh bhasha chunein jo dil ko bhaye.",

    // Hero
    hero_headline: "Ek aisi jagah jahan aap bas baat kar sakein… bina kisi judgment ke",
    hero_subheadline: "Aapko sab kuch samjhane ki zaroorat nahi hai. Yahan aapko hamesha mazboot rehne ki zaroorat nahi hai.",
    hero_vent: "Kisi se baat karein",
    hero_breath: "Saanson ka ehsaas",
    hero_descent: "Dhire dhire neeche chalein",
    hero_cta: "Ek message se shuru karein",
    hero_nudge: "Koi pressure nahi hai. Aap jab chahein chhod sakte hain.",

    // NEW: Soft Entry
    soft_entry_title: "Kabhi kabhi aapko answers ki zaroorat nahi hoti.",
    soft_entry_body: "Bas koi chahiye hota hai jo aapke saath baith sake.",

    // Section 2 - Invitation
    sec2_title: "Ek jagah… jahan aap bas reh sakte hain, jab kahin aur rehna mushkil ho.",
    sec2_sub: "Antaryatra ek aisa space hai jahan insaan sabse pehle aata hai.",
    sec2_val_fix: "Main yahan theek hone nahi aaya/aayi hoon.",
    sec2_val_strength: "Mujhe yahan strong dikhne ki zarurat nahi hai.",
    sec2_val_content: "Mera dukh kisi ka content nahi hai.",
    sec2_desc: "Yahan baatein aapki speed par hoti hain — aise logon ke saath jo sirf sunte hain.",

    // Section 3 - Intention
    sec3_title: "Aapki is journey ka maqsad.",
    sec3_sub: "Kyunki har dard ko jawaab nahi chahiye hota. Kuch dard ko bas ek saath chahiye.",
    sec3_desc: "Log hamesha motivation nahi chahte — wo bas chahte hain ki koi unhe bina judge kiya samjhe.",
    sec3_quote: "Bas akele nahi jhelna ye sab.",

    // Section 4 - States
    sec4_title: "Agar aap yahan hain…",
    sec4_state1: "Chup-chaap dard mein",
    sec4_state1_desc: "Aapko ise perfect shabdon mein kehne ki zaroorat nahi hai.",
    sec4_state2: "Sab kuch zyada lag raha",
    sec4_state2_desc: "Thoda rukiye. Saans lijiye. Taiyari hone par baat karein.",
    sec4_state3: "Strong reh ke thak gaye",
    sec4_state3_desc: "Yahan aapko har bojh akele dhone ki zarurat nahi.",
    sec4_state4: "Samajhna chahte hain",
    sec4_state4_desc: "Yeh koi social media feed nahi hai. Yeh ek sukoon bhari baatcheet hai.",
    sec4_state5: "Soul level par",
    sec4_state5_desc: "Koi label nahi. Koi forced belief nahi.",
    sec4_nudge: "Aap choti shuruat kar sakte hain. Ek message bhi kaafi hai.",
    sec4_cta: "Ek message se shuru karein",

    // Section 5 - Guides
    sec5_title: "Agar aapne kabhi kisi ki madad karni chahi ho… par pata na ho kaise",
    sec5_badge: "Saath Chalne Ki Kala",
    sec5_sub: "Aapko yahan kisi ko theek karne ki zaroorat nahi hai. Aapko perfect shabdon ki zaroorat nahi hai. Bas saath hona hi kaafi hai.",
    sec5_quote: "Mujhe unhe theek nahi karna. Bas unhe itna safe feel karana hai ki wo khud ka saamna kar sakein.",
    sec5_guide_tagline: "Asli log. Sunte hue, control nahi karte hue.",
    sec5_apply: "Ek baar saath baith kar dekhein",

    // Trust Layer
    trust_title: "Aap jab chahein ja sakte hain.",
    trust_desc: "Agar aapko theek na lage toh aapko continue karne ki zaroorat nahi hai. Rukne ka koi pressure nahi hai. Bas shuruat karne ki jagah hai.",

    // Section 6 - Roots
    sec6_title: "Ye jagah kis liye khadi hai",
    sec6_sub: "Support insani mehsoos hona chahiye, transactional nahi. Yahan, aapki kahani ko izzat di jati hai — jald-baazi nahi. Koi performance nahi. Koi pressure nahi. Koi manipulation nahi.",
    sec6_p1: "Maujoodgi dein",
    sec6_p1_desc: "Ek sunne wala kaan — bina pressure, bina jald-baazi ke.",
    sec6_p2: "Imandari ko badhava dein",
    sec6_p2_desc: "Koi performance nahi. Koi mask nahi. Mazbooti ki zaroorat nahi.",
    sec6_p3: "Vulnerability ko protect karein",
    sec6_p3_desc: "Aapki kahani pavitra hai. Kabhi content nahi. Kabhi expose nahi.",
    sec6_quote: "Support ka bhavishya tez technology nahi hai — ye aur bhi zimmedar insaniyat hai.",
    sec6_desc: "Jahan logon ko sunne ke liye chillane ki zaroorat nahi hoti. Jahan care dhire hoti hai, aur maujoodgi speed se zyada maayne rakhti hai.",

    // Section 8 - Promise
    sec8_title: "Ek shaant waada",
    sec8_promise: "Aap koi aisi cheez nahi hain jise solve kiya jaye.",
    sec8_desc: "Aap yahan apna samay le sakte hain — bhale hi aapko abhi na pata ho ki aap kya dhoond rahe hain.",
    sec8_cta: "Jab taiyaar hon tab baat karein",
    sec8_sub_cta: "Aap jahan hain, hum wahi milenge.",
    sec8_nudge: "Bas ek saans se shuru karein",
    sec8_new_here_cta: "Naye hain? Dil halka karein",
    sec8_nudge_text: "Pehli baar aaye hain?",

    // About Page
    about_quiet: "Ek Shaant",
    about_rebellion: "Vidroh",
    about_intro: "Antaryatra ek startup nahi hai; yeh modern duniya ke liye ek human-led space hai.",
    about_exhaustion: "Humne ise isliye banaya kyunki humein pata hai “perform karte rehne” wali iss loud aur thaka dene wali internet ki reality.",
    about_space: "Yahaan tum dheere ho sakte ho— ek aisa digital sthan jahan tumhe perfect hone ki zarurat nahi, sirf khud hone ki zarurat hai.",
    about_you: "",
    about_philosophy_title: "Hamari Soch",
    about_philosophy_body: "Hum maante hain ki technology ko insaan ki rooh ki seva karni chahiye, na ki usse exploit karna chahiye. Hum “Calm yet Firm” hain— logon ke saath gentle, par unki peace ko protect karne mein clear aur strong.",
    about_version: "Sanctuary v1.0",

    // Ethics & Safety Page
    ethics_title: "Suraksha aur Bharosa",
    ethics_tagline: "Hamari taraf se ek seedha aur saaf vaada.",
    ethics_data_title: "Aapka Data, Sirf Aapka",
    ethics_data_desc: "Hum aapka data bechte nahi hain. Hum aapki baatein advertisers ke saath share nahi karte. Aapke private thoughts yahan koi commodity nahi hain— yeh hamare beech ke trust ki buniyad hain.",
    ethics_anon_title: "Pehle Suraksha, Phir Pehchaan",
    ethics_anon_desc: "Agar aap safe feel nahi karte, toh real naam use karna zaroori nahi hai. Hum aapki identity ko protect karte hain, taaki aap bina darr ke apni baat keh sakein. Aap jaise hain, waise hi yahan swagat hai.",
    ethics_abuse_title: "Galat Vyavahar ke liye Zero Tolerance",
    ethics_abuse_desc: "Yeh ek safe space hai. Harassment, hate, ya kisi bhi tarah ka exploitation yahan bilkul allow nahi hai. Humne clear boundaries rakhi hain taaki yeh jagah shaant aur surakshit rahe. Jo inhe todta hai, usse turant hata diya jaata hai.",
    ethics_human_title: "Insaan Pehle, Technology Baad Mein",
    ethics_human_desc: "Yahan aap real logon se baat kar rahe hain. Technology sirf connection banati hai— asli support insaan se hi aata hai, na ki algorithms se.",
    ethics_integrity_title: "Seedha aur Imaandaar Model",
    ethics_integrity_desc: "Hum “value-for-value” model par kaam karte hain. Na hum likes ke peeche bhaagte hain, na engagement ke. Hamare liye seedha sa rule hai: har feature user ki peace ko protect kare, aur integrity ko compromise na kare.",
    ethics_crisis_title: "Zaroori Suchna",
    ethics_crisis_desc: "Antaryatra ek peer support platform hai— yahan aap dheere ho sakte hain, aur clarity pa sakte hain. Lekin yeh emergency medical care ka replacement nahi hai. Agar aap ya koi aur turant khatre mein hai, toh please apne local emergency services se turant sampark karein.",

    // Support Page
    support_title: "Madad chahiye?",
    support_desc: "Chahe aapko koi bug mila ho, safety concern ho, ya bas koi suggestion dena ho— hum sun rahe hain.",
    support_contact_title: "Humse sampark karein",
    support_reply_time: "Hum aam taur par 24 ghante ke andar reply karte hain.",

    // Crisis Page
    crisis_title: "Agar aap sankat mein hain",
    crisis_desc: "Agar aap turant khatre mein hain ya khud ko nuksaan pahunchane ke baare mein soch rahe hain, toh kripya turant professional madad lein.",
    crisis_hope: "Aap akela nahi hain—madad aur umeed dono maujood hain.",
    crisis_platform_note: "Antaryatra ek peer support platform hai, aur life-threatening emergencies handle karne ke liye bana nahi hai.",
    crisis_instruction: "Kripya turant madad ke liye upar diye gaye emergency numbers ka use karein.",

    // Terms Page
    terms_title: "Seva ke Niyam",
    terms_updated: "Last Updated: February 5, 2026",
    terms_disclaimer_title: "Swasthya sambandhit zaroori jaankari",
    terms_disclaimer_1: "ANTARYATRA koi medical service, suicide prevention line, ya clinic nahi hai.",
    terms_disclaimer_2: "Is platform par jo content aur baatcheet hoti hai, woh sirf informational aur peer-support ke liye hai. Yeh medical advice, diagnosis, ya treatment nahi hai.",
    terms_disclaimer_3: "Agar aap suicide ke baare mein soch rahe hain, ya khud ko ya kisi aur ko nuksaan pahunchane ka vichaar aa raha hai, ya aapko lagta hai koi turant khatre mein hai, toh kripya turant apne local emergency services ko contact karein.",
    terms_sec1_title: "Seva ka swaroop",
    terms_sec1_p1: "Antaryatra ek technological platform hai jo support dhoondhne wale logon (\"Seekers\") ko support dene wale logon (\"Providers\" ya \"Guides\") se connect karta hai.",
    terms_sec1_p2: "Hum in Providers ko employ nahi karte. Hum unki advice ko control ya direct nahi karte. Hum conversations ke content ke liye zimmedar nahi hain.",
    terms_sec1_p3: "Aap yeh samajhte hain ki aapki interactions aapki apni zimmedari par hain.",
    terms_sec2_title: "Vyavahar aur Suraksha",
    terms_sec2_age: "Age Requirement:",
    terms_sec2_age_desc: "Is platform ko independently use karne ke liye aapka 18+ hona zaroori hai.",
    terms_sec2_zero: "Zero Tolerance:",
    terms_sec2_zero_desc: "Harassment, hate speech, sexual solicitation, ya predatory behavior par turant permanent ban lagega.",
    terms_sec2_privacy: "Privacy Respect:",
    terms_sec2_privacy_desc: "Chat mein apni personal details (phone number, address, etc.) share na karein. Safety ke liye conversations platform ke andar hi rakhein.",
    terms_sec3_title: "Providers ke liye niyam",
    terms_sec3_intro: "Provider ke roop mein sign up karte hi aap yeh maante hain ki:",
    terms_sec3_1: "Aap ek independent contributor/volunteer hain, Antaryatra ke employee nahi.",
    terms_sec3_2: "Aap medical diagnosis nahi denge, na hi medication prescribe karenge.",
    terms_sec3_3: "Aap har user ke saath samman aur maryada se baat karenge.",
    terms_sec3_4: "Aap users ko platform ke bahar payment ke liye approach nahi karenge.",
    terms_sec4_title: "Seva ka samapan",
    terms_sec4_desc1: "Hum kabhi bhi, bina notice ke, aapka access suspend ya terminate kar sakte hain.",
    terms_sec4_desc2: "Yeh khaas taur par tab lagu hota hai jab koi vyakti is space ke spirit— safety, kindness, aur respect—ko todta hai.",
    terms_sec5_title: "Zimmedari ki seema",
    terms_sec5_desc: "Law ke maximum extent tak, Antaryatra Inc. kisi bhi indirect, incidental, special, ya consequential damages ke liye zimmedar nahi hoga. Ismein profit ya revenue ka loss bhi shamil hai, jo platform ke use ke direct ya indirect result ke roop mein ho sakta hai.",

    // Privacy Page
    privacy_title: "Privacy aur Cookies Niti",
    privacy_tagline: "Aapki baatein yahan surakshit hain.",
    privacy_short_title: "Seedhi baat",
    privacy_short_desc: "Hum aapka data bechte nahi hain. Hum aapko web par track nahi karte. Hum sirf utna hi data rakhte hain jitna zaroori hai— taaki aapko sahi listener se connect kar sakein aur platform ko safe rakh sakein.",
    privacy_sec1_title: "Hum kya data rakhte hain",
    privacy_sec1_acc: "Account Info:",
    privacy_sec1_acc_desc: "Email address (jahaan possible ho encrypted/hashed), optional username, aur profile details jo aap khud share karte hain.",
    privacy_sec1_chat: "Chat Logs:",
    privacy_sec1_chat_desc: "Aapki chat history securely store hoti hai, taaki aap baad mein dekh sakein. Yeh data safe aur encrypted hota hai.",
    privacy_sec1_usage: "Usage Data:",
    privacy_sec1_usage_desc: "Basic logs—jaise login time ya errors— taaki hum bugs fix kar sakein aur system improve kar sakein.",
    privacy_sec2_title: "Hum aapka data kaise use karte hain",
    privacy_sec2_li1: "Aapko sahi support Provider se connect karne ke liye.",
    privacy_sec2_li2: "Abusive users ko detect aur ban karne ke liye (safety ke liye).",
    privacy_sec2_li3: "Important account updates bhejne ke liye (jaise password reset).",
    privacy_sec2_li4: "Hum aapka data advertisers ko nahi bechte.",
    privacy_sec3_title: "Cookies ka istemaal",
    privacy_sec3_intro: "Hum digital minimalism follow karte hain. Hum sirf zaroori cookies use karte hain:",
    privacy_sec3_auth_title: "Authentication Cookies",
    privacy_sec3_auth_desc: "Aapko securely logged in rakhne ke liye (HttpOnly).",
    privacy_sec3_pref_title: "Preference Cookies",
    privacy_sec3_pref_desc: "Aapki preference yaad rakhne ke liye (jaise Dark Mode ya Light Mode).",
    privacy_sec3_tracking: "Hum koi third-party tracking tools (jaise Facebook Pixel) use nahi karte jo aapko internet par follow karein.",
    privacy_sec4_title: "Suraksha",
    privacy_sec4_desc1: "Hum data ke liye industry-standard encryption (SSL/TLS) use karte hain.",
    privacy_sec4_desc2: "Hamari team mein strict access controls hain— iska matlab aapki private chats kisi ko casually accessible nahi hoti. Sirf zarurat padne par (jaise safety investigation, court order, ya life-threatening situation) hi access liya jaata hai.",

    // Footer
    foot_tagline: "Andruni safar, badi narmi se.",
    foot_copy: "© 2026 Antaryatra Sanctuary.",
    foot_micro: "Apni raftaar se chalein • Jab chahein chhod dein • Koi pressure nahi",

    // Wisdom Section
    wisdom_loading: "Library se gyaan ikattha kiya ja raha hai...",
    wisdom_title: "Sanctuary ka Gyaan",
    wisdom_desc: "Reflections aur vichaar jo aapki feelings ko samajhne mein madad karenge.",
    wisdom_cta: "Shaanti se enter karein",
    wisdom_fallback_title: "Taiyar ho raha hai...",
    wisdom_fallback_body: "Ye scroll abhi translate ho raha hai. Tab tak English mein padhein.",
    wisdom_reflections: "Vichaar (Reflections)",
    wisdom_back: "Wapas Library mein chalein",
    wisdom_read_more: "Aur padein",
    wisdom_further: "Aur Gyaan",

    // Vent Box
    vent_title: "Dil Halka Karein",
    vent_freely: "Aapko sab kuch samjhane ki zaroorat nahi hai.",
    vent_begin_quietly: "Dheere se shuru karein",
    vent_begin_desc: "Har cheez samjhana zaroori nahi. Bas shuru karein.",
    vent_fire_title: "Jalti hui yaadein",
    vent_fire_desc: "Un baaton ke liye jinka roshni banna zaroori hai.",
    vent_water_title: "Khula Samundar",
    vent_water_desc: "Un baaton ke liye jo bas khamoshi mein kho jaani chahiye.",
    vent_canvas_water_title: "Samundar ka kinaara",
    vent_canvas_water_desc: "Apna bojh yahan likhiye. Ye samundar use sambhalne ke liye kaafi gehra hai.",
    vent_canvas_fire_desc: "Apna dukh yahan likhiye. Ye aag use roshni mein badal degi.",
    vent_placeholder: "Mujhe bhari lag raha hai kyunki...",
    vent_release_water: "Gehraiyon mein chhod dein",
    vent_release_fire: "Roshni ko saunp dein",
    vent_anim_water: "Samundar bahut bada hai. Ye bojh chhota sa. Ab aap halka mehsoos kar sakte hain.",
    vent_anim_fire: "Agni ne ise sweekar kiya. Aapka bojh ab kam ho gaya hai.",
    vent_complete_title: "Ab aap halka mehsoos kar rahe hain.",
    vent_complete_desc: "Aapka bojh ab khamoshi mein gum ho chuka hai.",
    vent_complete_desc_new: "Ab aap Sanctuary mein apni jagah lene ke liye taiyar hain.",
    vent_complete_cta: "Wapas Sanctuary mein aayein",
    vent_complete_cta_new: "Sanctuary mein aayein",
    vent_complete_cancel: "Wapas bahar ki duniya mein jaayein",
    vent_mute: "Aawaz band karein",
    vent_unmute: "Aawaz shuru karein",

    // The Living Breath
    breath_title: "Saanson ka Ehsaas",
    breath_desc: "Aaj aap kaisa mehsoos kar rahe hain?",
    breath_turb_title: "Besukooni (Turbulence)",
    breath_turb_desc: "Tufaan mein sukoon dhoondna.",
    breath_still_title: "Thehrav",
    breath_still_desc: "Khamoshi mein hi sachhai dikhti hai.",
    breath_inert_title: "Thaka hua mann",
    breath_inert_desc: "Aaram karna rukna nahi, taaqat ikattha karna hai.",
    breath_label_turb: "Bechain",
    breath_label_inert: "Bhari",
    breath_label_still: "Sukoon",
    breath_wake: "Touch karein",

    // Sanctuary Settings
    set_title: "Settings jo dil ko bhayein",
    set_theme_title: "Mann ka mausam",
    set_light: "Subaah hogai maamu",
    set_dark: "Raat akeli ha",
    set_lang_title: "Dil ki bhasha",
    set_lang_search: "Bhasha dhoondein...",
    set_lang_resonate: "Wahi chunein jo dil ko sahi lage.",
    set_lang_en_sub: "Duniya ki zubaan",
    set_lang_hi_sub: "Meri apni bhasha",
    set_tagline: "Aapki raaftar, aapka hi sansaar",
    set_lang_missing: "Ye bhasha abhi tak sanctuary ka hissa nahi bani.",
    set_close_account: "Apna Account Band Karein",
    set_close_warning_title: "Thoda Intezaar?",
    set_close_warning_desc: "Account band karne se aapka profile gayab ho jayega aur aapki active journey ruk jayegi. Aapki yaadein aur history 'The Books of Life' mein surakshit rahegi, par aap phir login nahi kar payenge.",
    set_cancel: "Sanctuary mein rahein",
    set_confirm_close: "Band karne ki pushti karein",

    // Mobile Bottom Nav
    nav_home: "Meri Jagah",
    nav_chats_tab: "Baatein",
    nav_wisdom_tab: "Gyaan",
    nav_profile_tab: "Profile",

    // Onboarding
    ob_nudge: "Isme ek minute se bhi kam lagega.",
    ob_inhale: "Saans andar lein…",
    ob_hold: "Rokein…",
    ob_exhale: "Chhod dein…",
    ob_safe_space_title: "Apni surakshit jagah banayein",
    ob_safe_space_sub: "Aapki identity hamare paas bilkul safe aur encrypted hai.",
    ob_real_name_label: "Asli Naam (Bilkul gupt)",
    ob_real_name_sub: "Ye sirf aapke aur upar wale ke beech rahega. 🔒",
    ob_email_label: "Email",
    ob_email_error: "Ye email thoda galat lag raha hai.",
    ob_dob_label: "Janam tithi (DOB)",
    ob_pass_label: "Password banayein",
    ob_pass_len: "Kam se kam 8 characters",
    ob_pass_upper: "Ek badi ABCD (A-Z)",
    ob_pass_num: "Kam se kam ek number (0-9)",
    ob_captcha_label: "Ek chhota sa sawal: {a} + {b} kitne hote hain?",
    ob_captcha_placeholder: "Aapka jawaab",
    ob_cta_begin: "Aage badhein",
    ob_nudge_bottom: "Aap jab chahein chhod sakte hain.",
    ob_login_prompt: "Pehle se account hai?",
    ob_login_link: "Login karein",
    ob_anon_name_label: "Ek Gupt Naam (Anonymous Name)",
    ob_anon_name_gen: "Naya banayein",
    ob_anon_name_sub: "Duniya aapko isi naam se jaanegi. Aapka asli naam chhupa rahega.",
    ob_anon_name_magic: "Yahi aapki pehchan hai. ✨ Ye aap par jachta hai.",
    ob_age_warn_title: "Umra ki seema",
    ob_age_warn_desc: "Hum aapke safar ka samman karte hain, par privacy niyam ke kaaran Antaryatra sirf 18 saal se upar ke logon ke liye hai.",
    ob_age_crisis: "Agar aapko turant madad chahiye, toh Childline (1098) par sampark karein.",
    ob_gender_label: "Ling (Gender)",
    ob_aadhaar_label: "Aadhaar ID (Zaroori nahi)",
    ob_aadhaar_sub: "Ye band tala-chabi mein rahega, koi nahi dekh sakega.",
    ob_back: "Peeche",
    ob_finish: "Safar shuru karein",
    ob_starting: "Shuru ho raha hai...",
    ob_step1_title: "Ek nayi shuruat",
    ob_step1_head: "Apne andar ki yatra shuru karein.",
    ob_step1_body: "Pehla kadam lene ke liye sab kuch pata hona zaroori nahi hai.",
    ob_step2_title: "Bas thodi der aur",
    ob_step2_head: "Apne aap ko ek naam dein.",
    ob_step2_body: "Aapka anonymous naam chuna aapke hath mein hai — ye khud ko samajhne ka ek chhota sa tareeka hai.",
    ob_storm_head: "Har toofan ke beech ek thehrav hota hai.",
    ob_storm_body: "Ek bechain mann bahut tishn (powerful) ho sakta hai. Hum yahan aapka anchor banne mein madad karenge.",
    ob_still_head: "Thehrav hi aapki taaqat hai.",
    ob_still_body: "Aapka andar ka sukoon saaf hai. Yahan hum aapko wo sunne mein madad karenge jo khamoshi kehna chahti hai.",
    ob_inert_body: "Sanctuary mein apna pehla kadam aaram se rakhein.",

    // Dashboard
    dash_inner_garden: "Mann ka aangan",
    dash_burn_worry: "Chinta Se Mukti",
    dash_nurture_tips: "Narm Sujhaav",
    dash_diary_cta: "Apni Diary likhein",
    dash_find_guide: "Apne liye Guide dhoondein",
    dash_support_circle: "Sahara aur Saath",
    dash_pending_req: "Naye log...Intezaar mein",
    dash_impact: "Badlav jo aap laye",
    dash_profile_views: "Kitne logo ne dekha",
    dash_online: "Online",
    dash_offline: "Offline",
    dash_availability: "Availability",
    dash_connect_guide: "Guide se judiye",
    dash_search_conv: "baat search karein",
    chat_search_placeholder: "baat search karein",
    chat_intro_title: "Aapki Baatcheet",
    chat_intro_body: "Bayein taraf se ek discussion choose karein apni journey continue karne ke liye, ya bas saansein lijiye.",
    dash_recent: "Abhi ki",
    dash_favourites: "Manpasand",
    dash_archived: "Archive ki gayi",
    dash_archived_chat: "Purani baatcheet",
    dash_silence_allowed: "Yahan khamoshi bhi thik hai.",
    dash_take_time: "Baatcheet jaldi shuru karna zaroori nahi. Apna waqt lijiye.",
    prof_my_profile: "Meri Profile",
    prof_manage_details: "Apni jaankari aur pasand manage karein.",
    prof_expertise_label: "Meri Expertise (Categories)",
    prof_journey_saved_msg: "Aapka safar safe hai. Jab chahein wapas aa sakte hain.",
    dash_weekly_impact: "Hafte ka Badlav",
    dash_sessions_label: "Baatcheet",
    dash_rating_label: "Rating",
    dash_updated_just_now: "Abhi update hua. Tap karke dekhein.",
    dash_provider_console: "Provider Control Room",
    dash_presence_sub: "Apni maujoodgi manage karein",
    dash_record_reflections: "Apne vichaar record karein",
    dash_availability_label: "Maujoodgi",
    chat_privacy_notice: "Yeh baatcheet private aur safe hai.",
    cat_manage_title: "Apne Support Areas Chunnein",
    cat_seeker_sub: "Wo raaste chunein jinpe aap guidance chahte hain.",
    cat_provider_sub: "Wo areas chunein jahan aap help kar sakte hain.",
    cat_label_EMOTIONAL_SUPPORT: "Emotional Support",
    cat_desc_EMOTIONAL_SUPPORT: "Anxiety, stress, akelaapan, ya jab bas dil ki baat karni ho.",
    cat_label_RELATIONSHIPS: "Rishte aur Social Life",
    cat_desc_RELATIONSHIPS: "Relationships, parenting, aur shaadi se judi baatein.",
    cat_label_LIFE_CHALLENGES: "Life Challenges",
    cat_desc_LIFE_CHALLENGES: "Career, finances, education, ya business ki mushkilein.",
    cat_label_HIGH_RISK: "High Risk (Strict)",
    cat_desc_HIGH_RISK: "Sensitive aur mushkil haalaat ke liye specialized guidance.",
    cat_label_SPIRITUAL: "Aadhyatmik aur Personal Growth",
    cat_desc_SPIRITUAL: "Khud ki talaash aur spiritual vikas.",
    cat_label_SUICIDE_PREVENTION: "Suicide Prevention",
    cat_desc_SUICIDE_PREVENTION: "Suicide rokne aur crisis ke waqt turant madad.",
    cat_label_ADDICTION: "Addiction Recovery",
    cat_desc_ADDICTION: "Addiction aur galat aadaton se bahar nikalne mein madad.",
    cat_label_TRAUMA: "Trauma aur Abuse Support",
    cat_desc_TRAUMA: "Trauma se ubharne aur abuse ke khilaaf sahaara.",
    chat_archive_action: "Archive karein",
    chat_unarchive_action: "Wapas layein",
    chat_welcome_namaste: "Namaste & Welcome",
    chat_welcome_body: "Ek gehri saans lijiye, Seeker. Yahan aap safe hain.",
    chat_welcome_body_guide: "Gehri saans lijiye, Guide. Aapki maujoodgi hi dusron ka sukoon hai.",
    chat_welcome_time: "Baatcheet jaldi shuru karna zaroori nahi. Apna waqt lijiye, Seeker.",
    chat_welcome_time_guide: "Aapka space shaant hai. Dusron ki sunne ke liye taiyar rahein.",
    chat_empty_matches: "Kuch nahi mila",
    chat_empty_favs: "Koi manpasand baatcheet nahi",
    chat_empty_archived: "Koi archive ki gayi baatcheet nahi",
    chat_empty_conv: "Abhi tak koi baatcheet nahi hui",
    chat_role_guide: "Guide",
    chat_role_seeker: "Seeker",

    // Errors
    err_generic: "Maaf kijiyega, kuch to gadbad ho gayi ha daya!",
    gate_logout_title: "Kahan Chale, Babumoshai?",
    gate_logout_body: "Aye musafir, Kya jaana zarrori ha?",
    gate_cancel_logout: "Thamba!",
    gate_confirm_logout: "Chale Chalo",
    gate_logout_prep: "Ek gehri saans chhodein... vidayi ki taiyari.",
    gate_logout_done: "Bahar ki duniya mein aapka safar sukhad ho.",
    prof_personal_details: "Meri Jaankari",
    prof_username: "Username",
    prof_full_name: "Pura Naam",
    prof_gender: "Gender",
    prof_no_expertise: "Koi expertise nahi chuni gayi.",
    prof_update_success: "Profile sahi se update ho gayi",
    prof_update_fail: "Update karne mein dikkat hui",
    prof_categories_success: "Expertise update ho gayi",
    prof_categories_fail: "Categories update nahi ho payin",
    err_starting: "Shuru ho raha hai...",

    // Phase 3: Auth & Gateway
    auth_login_welcome: "Aaiye, aapka h intezaar tha",
    auth_login_btn: "Andar aayein",
    auth_forgot_title: "Password bhool gaye?",
    auth_forgot_desc: "Password change karne ke liye apna email neeche add kariye",
    auth_forgot_email_label: "Email Address",
    auth_forgot_email_placeholder: "you@example.com",
    auth_forgot_cta: "Reset Link Bhejiye",
    auth_forgot_back: "Bahar Jayein",
    auth_2fa_verify_btn: "Verify karein",
    auth_2fa_back_link: "Wapas Login par jayein",

    // Profile
    prof_gender_male: "Purush",
    prof_gender_female: "Mahila",
    prof_gender_lgbt: "LGBT+ Parivar",
    acc_email_label: "Email",
    auth_forgot_check_mail: "Apna mail check karein",
    auth_forgot_sent_to: "Agar aapka account",
    auth_forgot_instructions: "ke liye hai, toh aapko jald hi password reset link mil jayega.",
    auth_login_prompt: "Antaryatra ke saath apna safar jaari rakhein.",
    auth_recovery_link: "Password bhool gaye?",
    auth_new_text: "Pehli baar aaye hain?",
    auth_new_link: "Account bana lijiye",
    auth_new_prompt: "Pehli baar aaye hain? Account bana lijiye",
    gateway_title: "Konsa rasta aapko pukaar rha ha?",
    gateway_sub: "Har safar ka pehla kadam hota hai. Wo raasta chunein jo aapko pukar raha hai.",
    gateway_seeker_path: "Sukoon ki talash",
    gateway_seeker_desc: "Paaiye ek safe space share karne aur reflect karne ke liye, jahan empathetic listeners aapko bina judge kiye sunte hain.",
    gateway_guide_path: "Raah Dikhana",
    gateway_guide_desc: "Jo andhere mein hain, unhe apni light dikhayein. Verification Required.",
    gateway_cta: "Safar shuru karein",

    // Dashboard Refinements
    dash_recent_chats: "Recent Baatcheet",
    dash_mood_tracker: "Mann ka Haal",
    dash_mood_sub: "Aapki emotional raaftar ko sambhaalna",
    dash_explore_providers: "Providers ko Dhundhein",
    dash_view_all: "Sab Dekhein",
    dash_view_profile: "Profile Dekhein",
    dash_chat_now: "Abhi Baat Karein",
    dash_mood_heavy: "Bhari",
    dash_mood_still: "Sukoon",
    dash_mood_bright: "Roshan",
    dash_mood_recorded_toast: "Mann ka haal darj kiya gaya! Share karne ke liye shukriya.",
    dash_mood_current_state: "Abhi ki sthiti",
    dash_mood_feeling_msg_start: "Aap",
    cookie_title: "Aapki Privacy",
    cookie_desc: "Hum sirf zaroori cookies istemal karte hain taaki aapka anubhav behtar rahe. Koi tracking nahi, sirf sukoon.",
    cookie_action: "Mujhe samajh aa gaya",
    cookie_read_more: "Aur jaaniye",
    privacy_sec5_title: "Data Deletion (Account Hatana)",
    privacy_sec5_desc: "Aap kisi bhi waqt apna account delete kar sakte hain. Deletion ke baad, aapka data 30 dino tak 'deactivated' state mein rahega. Is beech aap login karke apna account vapas paa sakte hain. 30 din baad aapki personal jankari permanently mita di jayegi. Note: Legal compliance aur safety audits ke liye, hum anonymized records ya minimal logs rakh sakte hain.",
    set_slide_to_confirm: "Delete karne ke liye slide karein",
    dash_mood_feeling_msg_end: "mehsoos kar rahe hain. Ek gehri saans lijiye.",
    dash_mood_graph_empty: "Apni emotional raaftar dekhne ke liye mann ka haal darj karna shuru karein.",
    dash_mood_graph_range: "Pichle 7 din",
    dash_explore_loading: "Aapke liye Guides dhoonde ja rahe hain...",
    dash_explore_empty: "Abhi koi available nahi hai.",
    dash_explore_empty_sub: "Aap intezaar kar sakte hain, categories badha sakte hain, ya baad mein wapas aa sakte hain.",
    dash_explore_modal_title: "Available Providers",
    dash_explore_msg_btn: "Message karein",
    dash_recent_loading: "Apne space se jud rahe hain...",
    dash_recent_empty: "Abhi tak koi baatcheet nahi hui. Jab aap taiyar hon, kisi Guide se judiye.",
    dash_recent_empty_title: "Har taraf khamoshi hai.",
    dash_recent_empty_sub: "Apni journey shuru karne ke liye kisi Guide se judiye.",
    dash_recent_empty_sub_provider: "Abhi koi active sessions nahi hain.",
    dash_recent_start_cta: "Baat shuru karein",
    dash_recent_msg_start: "Baat shuru karein...",
    dash_recent_msg_started: "Baatcheet shuru ho gayi...",
    dash_recent_prefix_me: "Aap: ",
    dash_recent_media_image: "📷 Photo",
    dash_recent_media_audio: "🎤 Voice Note",
    dash_recent_media_file: "📎 Document",
    dash_recent_media_letter: "📜 Khat (Letter)",

    dash_nurture_happy: "\"Khush rehne wala dil ek roshan suraj ki tarah hota hai.\" Iss ujaale ko apne journal mein darj karein.",
    dash_nurture_sad: "Dukh ko jaane dena hi behtar hai. Apne bhaari khayalon ko dhuyein ki tarah uda dein aur sukoon paayein.",
    dash_nurture_neutral: "Thehrav hi asli taaqat hai. Ek mindful breathing session ke saath apne aap se judiye.",
    dash_nurture_other: "Har jazbaat ek lehar ki tarah hai. Agar aapko sahare ki zaroorat ho, toh hum yahan hain.",

    // Diary
    diary_title: "Mera Sanctuary Journal",
    diary_empty: "Abhi aapki diary khali hai",
    diary_empty_sub: "Likhna shuru karne ke liye Sanctuary mein Digital Diary par jayein.",
    diary_view_all: "Sab Dekhein",
    diary_view_all: "Sab Dekhein",
    diary_pen_down: "Do shabd Likhein",
    diary_placeholder: "Apni yaadein darj karna shuru karein...",
    diary_mood_label: "Mann ka Haal",
    diary_write_prompt: "Pehle kuch toh likhiye.",
    diary_save_success: "Yaad aapke sanctuary mein surakshit hai",
    diary_save_error: "Yaad darj karne mein dikkat hui",
    diary_stop_label: "Rukein",
    diary_stop_tooltip: "Recording band karein",
    diary_start_tooltip: "Bolkar likhna shuru karein",
    diary_prompt_title: "Aaj ka Sujhaav",
    diary_weather_title: "Aapka Andaruni Mausam",
    diary_entry_date: "Entry ki Taarikh",
    diary_del_confirm: "Kya aap iss yaadon ko mitaana chahte hain?",
    diary_del_success: "Yaad mita di gayi",
    diary_del_error: "Yaad mitaane mein dikkat hui.",
    diary_del_tooltip: "Yaad mitayein",
    diary_reflecting_on: "Iss baare mein sochte hue",
    diary_archive_title: "Yaadon ka Pitara (Archive)",
    diary_memories_count: "{count} yaadein darj hain",
    diary_load_error: "Aapki diary ki yaadein load nahi ho payi.",

    // Grounding
    ground_morning: "Namaste, Suprabhat",
    ground_afternoon: "Namaste, Shubh Dopahar",
    ground_evening: "Namaste, Shubh Sandhya",
    ground_take_moment: "kuch pal apne liye",

    // Context Card
    ctx_mutual: "Dono ka Focus",
    ctx_primary: "Mukhya Focus",
    ctx_more: "+{count} aur",
    ctx_dismiss: "Abhi ke liye hataein",
    ctx_age: "Umra",
    ctx_critical: "Sattvic Sahara (Critical)",
    ctx_emotional: "Emotional Support",
    ctx_rel: "Rishte",
    ctx_life: "Zindagi ki Chunautiyan",
    ctx_spirit: "Aadhyatmik Pragati",

    // Breathing
    breath_title: "Saanson ka Ehsaas",
    breath_quote: "\"Mann ko shanti dein, toh aatma bolegi.\"",
    breath_headphones: "Behtar anubhav ke liye headphones ka istemaal karein.",
    breath_begin: "Kriya shuru karein",
    breath_inhale: "Andar saans lein",
    breath_hold: "Rokein",
    breath_exhale: "Baahar saans chhodein",
    breath_inhale_inst: "Naak se gehri saans andar lein...",
    breath_hold_inst: "Sabar rakhein... thodi der thahar jayein...",
    breath_exhale_inst: "Dheere se saans baahar chhodein... sab kuch jaane dein.",

    // Emotional Rhythm (Pre-chat)
    pc_title: "Aapka Mann, Aapki Raftaar",
    pc_question: "Abhi kaisa lag raha hai?",
    pc_context: "Ye share karne se aapki Guide ko samajhne mein madad milegi ki aap abhi kahan hain.",
    pc_continue: "Baat jaari rakhein",
    pc_skip: "Abhi rehne dein",

    // Moods
    mood_anxious: "Bechain",
    mood_lonely: "Akelaapan",
    mood_overwhelmed: "Bhaari-pan",
    mood_hopeful: "Ummeed",
    mood_chatting: "Bas yunhi",
    mood_confused: "Uljhan",
    mood_happy: "Khush",
    mood_sad: "Udaas",
    mood_neutral: "Theek-thak",

    // Sustain
    sustain_title: "Aapka Saath, sabka vikas",
    sustain_sub: "Hum aap jaise guardians par nirbhar hain taaki ye jagah sabke liye surakshit rahe.",
    sustain_global_tab: "Global Support (PayPal)",
    sustain_india_tab: "India (UPI)",
    sustain_guardian_title: "Guardian banein",
    sustain_guardian_desc: "Duniya ke kisi bhi kone se humein surakshit tareeke se support karein.",
    sustain_paypal_cta: "PayPal ke zariye contribute karein",
    sustain_paypal_trust: "Duniya bhar mein bharosemand. PayPal se surakshit payment.",
    sustain_upi_title: "UPI ke zariye support karein",
    sustain_upi_desc: "Zero fees. Kisi bhi UPI app se direct support.",
    sustain_copy: "Copy karein",
    sustain_copied: "Copy ho gaya",
    sustain_quote: "\"Sanctuary ki buniyaad barqarar rakhna uski raftaar se zyada zaroori hai.\"",
    support_reach_out_title: "Humse judiye",
    support_reach_out_body: "Antaryatra ke liye koi suggestions, complaints ya feedback hai? Ek second ke liye bhi mat hichkichaiye—humein care@antaryatra-app.com par likhiye. Hum aapki help ke liye humesha haazir hain.",

    // Apply
    apply_guide_title: "Guide ka agnipath",
    apply_guide_trust: "Kisi aur ka margdarshan karna ek pavitra zimmedari (sacred trust) hai.",
    apply_guide_not_marketplace: "Antaryatra koi marketplace nahi; ye ek sanctuary hai.",
    apply_guide_reflect: "Andar aane se pehle, hum chahte hain ki aap thoda chintan (reflect) karein.",
    apply_begin_reflection: "Chintan (Reflection) Shuru Karein",
    apply_prev_step: "Pichla Step",
    apply_success_title: "Application Mil Gayi Hai",
    apply_success_msg: "Aapka chintan (reflection) humein mil gaya hai. Hamari council ise review karegi, aur agar resonance hua toh hum aapko 'Virtual Tea' ke liye email karenge.",

    // Notifications
    note_title: "Soochnayein (Notifications)",
    note_empty: "Har taraf khamoshi hai.",
    note_empty_sub: "Nayi jaankari yahan dikhegi.",
    note_mark_all: "Sabhi ko padhein",
    note_clear_all: "Saaf karein",
    note_CHAT_NEW_MESSAGE: "{name} ne aapko message bheja hai.",
    note_WISDOM_NEW_SCROLL: "Library mein ek naya scroll juda hai: {title}",
    note_GUIDE_VERIFIED: "Aapka guide rasta verify ho gaya hai. Swagat hai, {name}.",
    note_GUIDE_PENDING: "Hum aapki application dekh rahe hain, {name}.",
    note_REACTION_NEW: "{name} ne aapke vichaar par pratikriya di hai.",
    note_BREATH_STREAK: "7-dino ka breathing streak! Yuhi jaari rakhein.",
    note_MOOD_PROMPT: "Aaj aapke mann ka mausam kaisa hai?",

    // Morning Brew
    brew_title: "Aaj ka Gyaan ka Ghoont",
    brew_read_article: "Article Padhein",
    brew_read_time: "{time} padhne mein",

    // Banner
    banner_verify_email: "Email Verify Karein",
    banner_verify_desc: "Puri features aur bharosa banane ke liye apna email verify karein.",
    banner_verify_btn: "Verify Karein",
    banner_sending: "Bheja ja raha hai...",
    banner_sent: "Verification link bhej diya gaya hai! Check karein.",
    banner_fail: "Link bhejne mein dikkat aayi.",
    banner_already: "Pehle se verify hai!",

    // Guest Dashboard
    dash_guest_title: "Guest Sanctuary Session",
    dash_guest_desc: "Apni yatra ko yaad rakhne aur providers se baat karne ke liye sanctuary join karein.",
    dash_guest_cta: "Apni Space Claim Karein",

    // Wisdom Section (hi)
    wisdom_loading: "Duniya bhar ka gyaan library se ikatha kiya ja raha hai...",
    wisdom_gathering: "Gyaan ikatha ho raha hai...",
    wisdom_for_you: "Aapke liye",
    wisdom_my_library: "Meri Library",
    wisdom_all_topics: "Sahi Mudde",
    wisdom_path_quiet: "Yeh raasta abhi khamosh hai.",
    wisdom_no_articles: "Yahaan abhi koi gyaan nahi hai.",
    wisdom_read_more: "Vistaar mein padhein",
    premium_history_title: "Gehri Samajh (Deep Insights)",
    premium_history_desc: "30-dino ki emotional rhythm aur deep patterns ko Guardian access ke saath unlock karein.",
    premium_history_cta: "Guardian Banein",
    // Onboarding & Gateway
    'gateway_title': 'Apni journey chunein',
    'gateway_subtitle': 'Har journey ek clear intention se shuru hoti hai.',
    'gateway_seeker_desc': 'Main yahan sukoon paane aur apna dil kholne ke liye hoon.',
    'gateway_guide_desc': 'Main yahan doosron ki help karne aur raah dikhane ke liye hoon.',
    'gateway_note': 'Dhyan dein: Aapka selection Sanctuary ke experience ko shape karega.',
    'ob_real_name_sub': 'Aap chahein toh share karein, varna ise private rakhne mein koi problem nahi.',
    'ob_age_sub': 'Isse humein sanctuary ko safe rakhne mein help milti hai.',
    'ob_legal_sub': 'Main confirm karta hoon ki meri age 18+ hai aur main Terms aur Privacy Policy se agree karta hoon.',
    'ob_final_step': 'Final Step',
    'ob_commitment_sub': 'Antaryatra ki sanctity banaye rakhne ke liye, humein aapki help chahiye.',
    
    // Quiz & Guide
    'quiz_next': 'Agla Sawal',
    'quiz_prev': 'Pichla Step',
    'quiz_start': 'Reflection shuru karein',
    'quiz_mirror_title': 'Satya ka Aaina (The Mirror of Truth)',
    'guide_circle_title': 'Circle of Ten',
    'guide_circle_subtitle': 'All-seer ki ek call',
    'guide_circle_desc': 'All-seer das ke original circle mein shaamil hone ke liye pehle 9 souls ki talaash kar raha hai. Ye koi naukri nahi hai; ye ek sacred witnessing hai.',
    'guide_sanctuary_note': 'Antaryatra koi bazaar nahi hai; ye ek sanctuary hai. Circle mein enter karne se pehle, aapko Mirror of Truth se guzarna hoga.',
    'ob_security_title': 'Accountability Layer',
    'ob_security_label': 'Slide karke verify karein',
    'ob_security_success': 'Verified',
    'ob_security_note': 'Sanctuary ko safe aur human banaye rakhne ke liye ek chota sa step.',
    'ob_name_label': 'Asli Naam (Private Rakha Jayega)',
  }
};
